import gql from 'graphql-tag';

export default gql`
query GetMyUser(
        $uuid: String!
        ) {
    getMyUsers(
        uuid: $uuid
    ) {
        uuid
        name
        desc
        currency
        payout
        year
        image
        langs
        auditor
        rating
        reviews
        payoutPayPalEmail
    }
}
`;
